<div class="grid grid-cols-1 gap-3 min-h-screen">

    <!-- tests -->
    <div class="w-full flex flex-col gap-3 ">
        <h2 class="text-lg font-semibold">Tests</h2>
        <div class="max-w-fit overflow-hidden">
            <ul class="flex gap-5 overflow-x-auto items-start mt-3 w-full scrollbar-hide pb-3">
                @for (i of [1,2,3,4,5,6,7]; track $index) {
                <li class="shrink-0">
                    <div
                        class="w-[15rem] h-[15rem] bg-white rounded-lg border flex flex-col gap-2 justify-center items-center">
                        <img class="w-[7rem] h-[7rem] object-contain"
                            src="https://cdn-icons-png.freepik.com/512/6795/6795827.png" alt="">
                        <p class="mt-2 max-w-sm">Test 1</p>
                    </div>
                </li>
                }
            </ul>
        </div>
    </div>
    <!-- tests -->
     <hr>
    <!-- certificate -->
    <div class="w-full flex flex-col gap-3 ">
        <h2 class="text-lg font-semibold">Certificates</h2>
        <div class="max-w-fit overflow-hidden">
            <ul class="flex gap-5 overflow-x-auto items-start mt-3 w-full scrollbar-hide pb-3">
                @for (i of [1,2,3,4]; track $index) {
                <li class="shrink-0">
                    <div
                        class="w-[15rem] h-[15rem] bg-white rounded-lg border flex flex-col gap-2 justify-center items-center">
                        <img class="w-[7rem] h-[7rem] object-contain"
                            src="https://cdn-icons-png.freepik.com/512/6795/6795773.png" alt="">
                        <p class="mt-2 max-w-sm">Certificate 1</p>
                    </div>
                </li>
                }
            </ul>
        </div>
    </div>
    <!-- certificate -->
     <hr>
    <!-- Badges -->
    <div class="w-full flex flex-col gap-3 ">
        <h2 class="text-lg font-semibold">Badges</h2>
        <div class="max-w-fit overflow-hidden">
            <ul class="flex gap-5 overflow-x-auto items-start mt-3 w-full scrollbar-hide pb-3">
                @for (i of [1,2]; track $index) {
                <li class="shrink-0">
                    <div
                        class="w-[15rem] h-[15rem] bg-white rounded-lg border flex flex-col gap-2 justify-center items-center">
                        <img class="w-[7rem] h-[7rem] object-contain"
                            src="https://cdn-icons-png.freepik.com/512/14607/14607662.png" alt="">
                        <p class="mt-2 max-w-sm">Badge 1</p>
                    </div>
                </li>
                }
            </ul>
        </div>
    </div>
    <!-- Badges -->
</div>